/* jshint esnext: true */
import { $document } from '../utils/environment';

export function closeAllOverlays() {
    $document.trigger('toggleNav.Nav', [false]);
    $document.trigger('toggleSearch.Search', [false]);
    $document.trigger('toggleServices.Services', [false]);
}
